import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { ModalService } from '@avla/ui-design';
import { TooltipInterface } from '@avla/ui-design/commons';
import { AuthService } from '@services';
import { emailSameAsInitial } from '@shared/validator/email.validator';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-recover-email',
  templateUrl: './modal-recover-email.component.html',
  styleUrls: ['./modal-recover-email.component.scss'],
})
export class ModalRecoverEmailComponent implements OnInit {
  public recoverEmailForm: FormGroup;
  public modalName: string = 'modalRecoverEmail';
  public isSearch: boolean = true;
  public isConfirm: boolean = false;
  public isOk: boolean = false;
  public emailConfirmed: string = '';
  public hiddenV2: boolean = true;
  public token: string | undefined;
  private responseRecoverEmailToken: string | undefined;

  public toolTip: TooltipInterface = {
    content: 'Ingresar un email válido',
    theme: 'default',
    position: 'right-top',
  };

  public height: number = window.innerHeight;
  @HostListener('window:resize')
  onResize() {
    this.height = window.innerHeight;
  }

  @ViewChild('recaptcha') recaptchaModel!: NgModel;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private authService: AuthService,
    private serviceCaptcha: ReCaptchaV3Service,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.setup();
  }

  setup(): void {
    this.recoverEmailForm = this.formBuilder.group({
      idOrganizationModal: ['', [Validators.required]],
      userModal: ['', [Validators.required]],
      passwordModal: ['', [Validators.required]],
      emailModal: [
        '',
        [
          Validators.required,
          emailSameAsInitial(this.emailConfirmed, this.isOk),
        ],
      ],
    });
  }

  get formInvalid(): boolean {
    return (
      this.recoverEmailForm.get('idOrganizationModal').invalid ||
      this.recoverEmailForm.get('userModal').invalid ||
      this.recoverEmailForm.get('passwordModal').invalid
    );
  }

  get searchIsDisabled(): boolean {
    if (this.recaptchaModel) {
      return this.formInvalid || this.recaptchaModel.invalid;
    } else {
      return this.formInvalid;
    }
  }

  get confirmEmailIsDisabled(): boolean {
    if (this.recaptchaModel) {
      return this.recoverEmailForm.get('emailModal').invalid || this.recaptchaModel.invalid;
    } else {
      return this.recoverEmailForm.get('emailModal').invalid;
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  closeModal(): void {
    this.modalService.close(this.modalName);
    this.recoverEmailForm.reset();
    this.isSearch= true;
    this.isConfirm= false;
    this.isOk= false;
    this.emailConfirmed= '';
    this.setup();
  }

  reInit() {
    this.recoverEmailForm.reset();
    this.isSearch= true;
    this.isConfirm= false;
    this.isOk= false;
    this.emailConfirmed= '';
    this.setup();
    this.hiddenV2= true;
  }

  async search() {
    if (!this.searchIsDisabled) {
      let token = null;
      if (this.hiddenV2) {
        try {
          token = await firstValueFrom(this.serviceCaptcha.execute('login'));
        } catch {
          this.hiddenV2 = false;
          token = this.token;
          return;
        }
      } else {
        token = this.token;
      }
      try {
        const responseRecoverEmail = await this.authService.recoverEmail(
          {
            organizationUnitName:
              this.recoverEmailForm.controls['idOrganizationModal'].value,
            username: this.recoverEmailForm.controls['userModal'].value,
            password: this.recoverEmailForm.controls['passwordModal'].value,
          },
          token
        );
        if (responseRecoverEmail) {
          this.recoverEmailForm.controls['emailModal'].setValue(
            responseRecoverEmail.email
          );
          this.responseRecoverEmailToken = responseRecoverEmail.token;
          this.isSearch = false;
          this.isConfirm = true;
          this.isOk = true;
          this.hiddenV2= true;
        }
      } catch {
        this.hiddenV2 = false;
      }
    }
  }

  async confirmEmail() {
    if (!this.confirmEmailIsDisabled) {
      let token = null;
      if (this.hiddenV2) {
        try {
          token = await firstValueFrom(this.serviceCaptcha.execute('login'));
        } catch {
          this.hiddenV2 = false;
          token = this.token;
          return;
        }
      } else {
        token = this.token;
      }
      try {
        const responseUpdateEmail = await this.authService.updateEmail({
          token: this.responseRecoverEmailToken,
          email: this.recoverEmailForm.controls['emailModal'].value,
        }, token);
        if (responseUpdateEmail) {
          this.emailConfirmed =
            this.recoverEmailForm.controls['emailModal'].value;
          this.isOk = responseUpdateEmail.isOk;
          this.setup();
          this.recoverEmailForm.controls['emailModal'].setValue(
            this.emailConfirmed
          );
          this.recoverEmailForm.controls['emailModal'].markAsTouched();
          if (this.isOk) {
            this.isConfirm = false;
          }
          this.hiddenV2= true;
        }
      } catch {
        this.hiddenV2 = false;
      }
    }
  }
}
